import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Interpolate } from "@/mk2/components/Interpolate";
import { Link } from "@/mk2/components/Link";
import {
    POST_IS_HOAX_ALERT_CONTENT,
    POST_IS_HOAX_ALERT_HEADING,
} from "@/mk/autogenerated/translations/PostIsHoaxAlert.d23874375b9459b98447d6738b824e18";
import { ACTIVE_SERVER_ID } from "@/mk/settings";

import styles from "./PostIsHoaxAlert.mscss";

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const PostIsHoaxAlert: React.FunctionComponent<Props> = ({ className }) => (
    <div className={cx(styles.PostIsHoaxAlert, className)}>
        <div className={styles.PostIsHoaxAlert__heading}>
            <span className={styles.PostIsHoaxAlert__heading__icon}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>{" "}
            {POST_IS_HOAX_ALERT_HEADING}
        </div>
        <div className={styles.PostIsHoaxAlert__info}>
            <Interpolate
                i18nKey={POST_IS_HOAX_ALERT_CONTENT}
                components={[
                    <Link
                        key="link"
                        to={
                            ACTIVE_SERVER_ID === 201
                                ? "/ine/co-je-konspiracna-teoria-a-preco-je-jej-sirenie-nebezpecne/"
                                : "/jine/co-je-konspiracni-teorie-a-proc-je-jeji-sireni-nebezpecne/"
                        }
                    />,
                ]}
            />
        </div>
    </div>
);

PostIsHoaxAlert.displayName = "PostIsHoaxAlert";

export default React.memo<Props>(PostIsHoaxAlert);
